import { render, staticRenderFns } from "./BaseTHead.vue?vue&type=template&id=70ae686b&"
import script from "./BaseTHead.vue?vue&type=script&lang=js&"
export * from "./BaseTHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports